
import { defineComponent } from 'vue';
import { icons, Icon } from '../assets/icons/icons';

export default defineComponent({
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true
    },

    alt: {
      type: String,
      default: null
    },

    size: {
      type: String,
      default: 'sm',
      validator(value: string) {
        return ['sm', 'md', 'lg', 'xl', '2xl', '3xl'].includes(value);
      }
    }
  },
  computed: {
    iconClasses(): (string | Record<string, boolean>)[] {
      return [
        `svg-icon svg-icon--${this.name} svg-icon--${this.size} svg-icon--${this.category}`,
        { 'svg-icon--loading': this.isLoading }
      ];
    },
    isLoading(): boolean {
      return this.name === 'spinner';
    },
    category(): string {
      return this.icon?.category;
    },
    viewBox(): string {
      return this.icon?.viewBox ?? '0 0 16 16';
    },
    icon(): Icon {
      return icons[this.name];
    }
  }
});
